require('angular');

angular.module('app').controller('cartController', CartController);
CartController.$inject = ['$http', '$scope','$rootScope', '$sce', '$window','ecommerce','promocode'];

function CartController($http, $scope,$rootScope, $sce, $window, ecommerce, promocode) {
    $scope.currency         = '';
    $scope.cart             = [];
    $scope.promocodes       = [];
    $scope.promocodeToAdd   = '';
    $scope.promocodeInfo    = '';

    $scope.init         = function(){
        promocode.getPromoCodes().then(function(response){
            $scope.promocodes = response.data;
        });

        $scope.fetchCart(true);
    }

    $scope.fetchCart    = function(onload){
        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'fetch-basket'
            }
        }).then(function(data){

            $scope.cart         = data.data.cart;
            $scope.currency     = data.data.currency;

            if(onload){
                ecommerce.viewCart($scope.cart, $scope.computeTotal(), $scope.currency);
            }
        });
    }

    $scope.computeTotal = function(){
        var total = 0.00;
        angular.forEach($scope.cart, function(item, key) {
            var toAdd = $scope.currency == 'EUR' ? parseFloat(item.price_eur) : parseFloat(item.price_pln);
            if(angular.isNumber(toAdd) && !isNaN(toAdd)){
                total = total + toAdd;
            }

        }, $scope);

        return total;
    }

    $scope.countItems = function(){
        var i = 0;
        angular.forEach($scope.cart, function(item, key) {
           i++;

        }, $scope);
        return i;
    }

    $scope.removeItem    = function(id){
        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'remove-item-from-basket'
            },
            data: {
                id: id
            }
        }).then(function(data){
            ecommerce.removeFromCart($scope.cart,$scope.computeTotal(), $scope.currency, id);
            $scope.fetchCart();
            $rootScope.$broadcast("removeBasketItem");
        });
    }

    $scope.proceedToCheckout = function($event){
        
        let acceptPolicyCheckbox = document.getElementById('acceptPolicy');
        if(!acceptPolicyCheckbox.checked){
            $event.preventDefault();
            acceptPolicyCheckbox.classList.add('notCheckedAlert');
        }
        ecommerce.beginCheckout($scope.cart,$scope.computeTotal(), $scope.currency, 'DUMMY_COUPON');
    }

    $scope.removePromocode = function(code){
        promocode.removePromoCode(code, $scope);
    }

    $scope.addPromocode = function(){


        promocode.addPromoCode($scope.promocodeToAdd, $scope);
    }

    $scope.computeTotalWas = function(){
        var total = 0.00;
        angular.forEach($scope.cart, function(item, key) {
            var toAdd = $scope.currency == 'EUR' ? (item.promocodes.length > 0 ? parseFloat(item.price_eur_was) : parseFloat(item.price_eur))  : (item.promocodes.length > 0 ? parseFloat(item.price_pln_was): parseFloat(item.price_pln));
            if(angular.isNumber(toAdd) && !isNaN(toAdd)){
                total = total + toAdd;
            }

        }, $scope);

        return total;
    }




}